import { useEffect, useState } from 'react';
import { CollectionPageState, CollectionPageStateParams } from '../state';
import { runInAction } from 'mobx';
import { useWixPatternsContainer } from '../providers';

export function useCollectionPageState(
  {
    pageTitle,
    hasHeader,
    hideHeaderTotal,
    ...rest
  }: CollectionPageStateParams = {},
  stateOverride?: CollectionPageState | undefined,
): CollectionPageState {
  const routerState = useWixPatternsContainer();
  const [state] = useState(
    () =>
      stateOverride ??
      new CollectionPageState({
        pageTitle,
        hasHeader,
        hideHeaderTotal,
        withinRouter: Boolean(routerState),
        ...rest,
      }),
  );

  useEffect(() => {
    runInAction(() => {
      state.pageTitle = pageTitle;
    });
  }, [pageTitle]);

  useEffect(() => {
    runInAction(() => {
      state.hasHeader = hasHeader;
    });
  }, [hasHeader]);

  return state;
}
